import { RuleFunction } from "@/models/components/inputs/RuleFunction";

export enum PROMPT_TYPE {
  TEXT,
  TEXTAREA,
  DATE,
}

export interface PromptModelInterface {
  label?: undefined | null | string;
  placeholder?: undefined | null | string;
  rules?: RuleFunction[];
  type: PROMPT_TYPE;
  title: string;
  content: string;
  value?: unknown;
  min?: string;
  max?: string;
  width?: string;
}
//
export class PromptModel implements PromptModelInterface {
  public content: string;
  public title = "";
  public label: null | string = null;
  public placeholder: null | string = null;
  public rules: RuleFunction[] = [];
  public type: PROMPT_TYPE;
  public value: unknown;
  public min?: string;
  public max?: string;
  public width = "400px";

  constructor(content: string, title = "", type = PROMPT_TYPE.TEXT) {
    this.content = content;
    this.title = title;
    this.type = type;
  }
}
